// extracted by mini-css-extract-plugin
module.exports = {"lightGradient":"sectionBackgrounds_lightGradient__X2SFS"};